import { AccountProviderType } from 'owa-accounts-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isTrueTimeEnabledForProvider(type: AccountProviderType): boolean {
    switch (type) {
        case 'Outlook':
            return isFeatureEnabled('cal-truTime');
        case 'Google':
            return isFeatureEnabled('cal-truTime-Google');
        default:
            return false;
    }
}
